import { FillFlip } from "@pdfking/filling"
import { RecordByPrimaryKey } from "@pdfking/templates"

import type { Flip } from "#internal"

export const FlipList = RecordByPrimaryKey<Flip>([
  { id: FillFlip.FLIP_EFFICIENT, name: "FLIP_EFFICIENT" },
  { id: FillFlip.FLIP_SAME_ORIENTATION, name: "FLIP_SAME_ORIENTATION" },
  { id: FillFlip.FLIP_AS_IS, name: "FLIP_AS_IS" },
  { id: FillFlip.FLIP_ROTATED, name: "FLIP_ROTATED" },
] as const)
